import React from "react"
import {SosJobTeaser, SosPressrelease, SosTeaser} from "../../../../packages/graphql-layer/src";
import CCOPicture from "../../fundamentals/CCOPicture";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOContainer33_66 from "../../fundamentals/CCOContainer33_66";
import {Box, Divider, Typography} from "@mui/material";
import {formatDate, truncateTree} from "../../../utility/componentUtil";
import {useTranslation} from "react-i18next";
import CCOLink from "../../fundamentals/CCOLink";
import CCOLinkText from "../../fundamentals/CCOLinkText";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";


export interface Props {
    cmTeaser: SosTeaser | SosPressrelease | SosJobTeaser,
    displayDate?: boolean
    hidePicture?: boolean
    hideDocType?: boolean
    lastElement?: boolean
    dataCypress?: string,
    order?: string
}

const SETTINGS_ORDER_DELIMITER = ' ';

const getDateByOrderValue = (props: Props) => {
    if (!props.displayDate) {
        return null;
    }

    let orderValue = '';
    if (props.order) {
        orderValue = props.order.substring(0, props.order.indexOf(SETTINGS_ORDER_DELIMITER));
    }

    let date;
    switch (orderValue) {
        case 'creationdate':
            date = props.cmTeaser.creationDate ?? undefined;
            break;
        case 'freshness':
            date = props.cmTeaser.modificationDate ?? props.cmTeaser.creationDate ?? undefined;
            break;
        case 'externallydisplayeddate':
            date = props.cmTeaser.extDisplayedDate ?? props.cmTeaser.modificationDate ?? props.cmTeaser.creationDate ?? undefined;
            break;
        default:
            console.error("Unknown sort field: ", orderValue);
    }

    return date ? formatDate(date) : null;
}

function C018StandardTeaser(props: Props) {
    const {t} = useTranslation();
    const isPreview = usePreviewContext().isPreview;
    const formattedDate = getDateByOrderValue(props);

    const isTeaserEmpty = !(props.cmTeaser.title || props.cmTeaser.teaserText);

    const renderTextContent = (teaser: SosTeaser) => {
        const teaserText = teaser?.teaserText?.textAsTree;

        return <>
            {!props.hideDocType && teaser ?
                <Typography variant='overline' sx={{marginBottom: '6px'}} {...metaDataProperty(isPreview, 'properties.teaserTitle', teaser.id)}>
                    {teaser.teaserTitle}</Typography>
                : null}
            {teaser.title || teaser.headline ?
                <CCOHeadline metadataId={teaser.id}
                    headline={teaser.title || teaser.headline}
                    propertyName={teaser.title ? 'properties.title' : 'properties.headline'}
                    type='h4'
                    margin={{b: 2}}
                    strong
                    justify='left'
                /> : null}
            {formattedDate ?
                <Typography
                    variant='caption' color='#757575' fontSize='1rem'>{formattedDate}</Typography> : null}
            {teaserText &&
                <Typography variant='body1' sx={{marginBottom: '8px'}} {...metaDataProperty(isPreview, 'properties.teaserText', teaser.id)}>
                    {truncateTree(teaserText, 200)}
                </Typography>
            }

            <CCOLinkText txt={t("c018_learn_more")}/>
        </>
    }

    if (isTeaserEmpty) {
        return (<></>);
    }

    const targetLink = props.cmTeaser.type === "SOSJobTeaser" && "deepLink" in props.cmTeaser
        ? props.cmTeaser.deepLink
        : props.cmTeaser.selfUrl;

    return <CCOContainer dataCypress={props.dataCypress} id={props.cmTeaser.id}>
        <Divider/>
        <CCOLink
            target={targetLink || ''}>
            <CCOContainer33_66
                left={!props.hidePicture && props.cmTeaser.picture ?
                    <Box overflow='hidden' width='100%' sx={{
                        'img': {
                            objectFit: 'cover!important',
                            width: '100%!important',
                            minWidth: '100%',
                        }
                    }}>
                        <CCOPicture name={props.cmTeaser.picture?.name}
                                    picture={props.cmTeaser.picture}
                                    orientation='landscape_ratio16x9'
                                    width='585'
                                    height='329'/>
                    </Box> : undefined}
                right={renderTextContent(props.cmTeaser as SosTeaser | SosPressrelease)}
            />
        </CCOLink>
        {props.lastElement ? <Divider/> : <></>}
    </CCOContainer>;
}

export default C018StandardTeaser